import type { ReactNode } from "react";
import * as PopoverPrimitive from "@radix-ui/react-popover";
import { FollowupFieldViewDecisionEnum } from "@/lib/api/generated/casedb";
import type { FollowupProposalView } from "../types/followupReviewView";
import { FOLLOWUP_BADGE_STATES, followupBadgeLabel } from "../constants/followupReviewLabels";

interface Props {
  proposals: FollowupProposalView[];
  open: boolean;
  onOpenChange(open: boolean): void;
  children: ReactNode;
}

/** The inline `F/U 1` badge on an ordinary field row; opens a popover of every proposal on it. */
export function FollowupBadge({ proposals, open, onOpenChange, children }: Props) {
  const pending = proposals.some((proposal) => proposal.decision === FollowupFieldViewDecisionEnum.Pending);
  const label = followupBadgeLabel(proposals.map((proposal) => proposal.arrivalOrdinal));
  return <PopoverPrimitive.Root open={open} onOpenChange={onOpenChange}>
    <PopoverPrimitive.Trigger asChild>
      <button type="button" className="cr-followup-badge"
        data-state={pending ? FOLLOWUP_BADGE_STATES.pending : FOLLOWUP_BADGE_STATES.decided}
        aria-expanded={open} aria-haspopup="dialog">{label}</button>
    </PopoverPrimitive.Trigger>
    <PopoverPrimitive.Portal>
      <PopoverPrimitive.Content asChild side="bottom" align="end" sideOffset={6} collisionPadding={8}
        onOpenAutoFocus={(event) => event.preventDefault()}>
        {children}
      </PopoverPrimitive.Content>
    </PopoverPrimitive.Portal>
  </PopoverPrimitive.Root>;
}
